import React from 'react'
import { roles, withProtectedRoute } from 'lib/auth'
import { useParams } from 'react-router-dom'
import { gql, useQuery } from '@apollo/client'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import BuildIcon from '@material-ui/icons/Build'
import EmptyPageState from 'components/empty-page-state'
import { useFeatureFlags, flags } from 'lib/feature-flags'
import Error from 'components/error'
import AppBar from '../register/app-bar'
import LoadingPage from './loading-page'
import StreamGroupEventMessagesPage from './stream'
import ContentUnavailable from 'components/content-unavailable'

const GET_GROUP_EVENT = gql`
  query ThingsToDoGroupEvent($slug: String!) {
    groupEvents(slug: $slug) {
      title
      slug
      startDateTime
      endDateTime
      timezone
      coachFacility {
        name
      }
      coach {
        id
        externalId
        pgaCoachEligible
        name
        coachProfile {
          displayName
          profilePhoto
          customSlug
        }
      }
      featuredImageUrl
      isCanceled
      registrationClosed
      registrationFull
      registrationCount
      maxAttendance
    }
  }
`

const EventMessages = () => {
  const { slug } = useParams()
  const [enabledMessagingService] = useFeatureFlags([
    flags.FLAG_MESSAGING_SERVICE,
  ])

  const { data, loading, error } = useQuery(GET_GROUP_EVENT, {
    variables: { slug },
  })

  const groupEvent = data?.groupEvents?.[0]

  const getPageContent = () => {
    if (loading) return <LoadingPage />
    if (error) return <Error error={error} />
    if (!groupEvent) return <Error statusCode={404} />
    if (!groupEvent.coach.pgaCoachEligible) return <ContentUnavailable />

    switch (enabledMessagingService) {
      case 'stream':
        return <StreamGroupEventMessagesPage event={groupEvent} />
      case 'maintenance':
      default:
        return (
          <Container maxWidth="sm">
            <EmptyPageState
              IconComp={() => <BuildIcon />}
              title="Under Maintenance"
              caption="We are currently in the process of upgrading your messaging experience! Please check back again in just a bit. 👍"
              removeButton
            />
          </Container>
        )
    }
  }

  return (
    <Box bgcolor="grey.100" style={{ minHeight: '100vh' }}>
      <AppBar />
      {getPageContent()}
    </Box>
  )
}

export default withProtectedRoute(EventMessages, roles.CONSUMER)
